import { render, staticRenderFns } from "./BeefBasicSettingsForm.vue?vue&type=template&id=4f84fd2a"
import script from "./BeefBasicSettingsForm.vue?vue&type=script&lang=js"
export * from "./BeefBasicSettingsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports